import React from 'react';
import { useLanguage } from '../../i18n/LanguageContext';
import '../static/ChurchLeaders.css';
import pastorImage from "../images/Pastor.jpg";
import simeonImage from "../images/Simeon.jpg";
import cullenImage from "../images/Cullen.jpg";

const teamMembers = [
    { name: 'Andy Tso',     image: pastorImage,  key: 'andyTso' },
    { name: 'Simeon Leung', image: simeonImage,  key: 'simeonLeung' },
    { name: 'Cullen Ye',    image: cullenImage,  key: 'cullenYe' },
];

const ChurchLeaders = () => {
    const { t } = useLanguage();

    return (
        <section className='team-section' id="pastor">
            <div className="team-header">
                <h1 className="team-title">{t('team.heading')}</h1>
                <p className="team-subtitle">{t('team.subtitle')}</p>
            </div>

            <div className="team-grid">
                {teamMembers.map((member, index) => (
                    <div key={index} className="team-member">
                        <div className="member-image-wrapper">
                            <img
                                src={member.image}
                                alt={member.name}
                                className="member-image"
                                loading="lazy"
                            />
                        </div>
                        <div className="member-info">
                            <h3 className='member-name'>{member.name}</h3>
                            <span className="member-role">{t(`team.members.${member.key}.role`)}</span>
                            <p className="member-bio">{t(`team.members.${member.key}.bio`)}</p>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default ChurchLeaders;
